<template>
  <div class="panel_one">
    <h3>查询你的报告信息</h3>
    <a-form
      :model="realData" 
      layout="vertical" 
      ref="formRef"
      @submit="handleSubmit" >
      <a-form-item field="type" label="选择查询的类别">
        <a-radio-group  v-model="realData.type" @change="radioChange">
          <a-radio :value="1">检验检测</a-radio>
          <a-radio :value="2">计量校准</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item field="number" :label="realData.type == 1 ? '报告编号' : '报告/证书编号'">
        <a-input 
          v-model="realData.number"
          :placeholder="realData.type == 1 ? '请输入报告编号' : '请输入报告/证书编号'"  />
      </a-form-item>
      <a-form-item field="customer" :label="realData.type == 1 ? '报告客户' : '报告/证书客户'">
        <a-input 
          v-model="realData.customer"
          :placeholder="realData.type == 1 ? '请输入报告客户名称' : '请输入报告/证书客户名称'"  />
      </a-form-item>
      <div class="button">
        <a-button html-type="submit" type="primary">查询</a-button>
        <a-button @click="handleCancel">重置</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { ref, getCurrentInstance } from 'vue'
export default {
  setup(props, context) {
    const { appContext: { config : { globalProperties } } } = getCurrentInstance();
    let realData = ref({
      type: 1,
      customer: '',
      number: ''
    })
    let formRef = ref(null)

    function handleSubmit({values, errors}) {
      console.log(values)
      if(values) {
        globalProperties.$API.SelectReport(values).then(res => {
          if(res.data.code == 200) {
            context.emit('show', res.data.data)
          }else {
            globalProperties.$message.error(res.data.msg || '操作失败')
            context.emit('show', null)
          }
        })
      }
    }

    function handleCancel() {
      formRef.value.resetFields();
      context.emit('show', null)
    }

    function radioChange(value) {
      formRef.value.resetFields();
      realData.value.type = value
    }

    return {
      realData,
      formRef,
      handleSubmit,
      handleCancel,
      radioChange
    }
  }
}
</script>

<style lang='scss'>
  .panel_one {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 5px 20px 0px rgba(0,41,98,0.10); 
    margin: 0 auto 0;

    & > h3 {
      line-height: 33px;
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 25px;
    }

    .arco-form-item-content,
    .arco-radio-group {
      width: 100%;
    }
    .arco-radio-group {
      display: flex;
      
    }
    .arco-radio {
      width: calc((100% - 10px) / 2);
      height: 40px;
      padding: 10px 16px;
      border: 1px solid #e5e6eb;
      border-radius: 4px;
      margin-right: 10px;
      font-weight: 600;

      &:last-child {
        margin-right: 0;
      }
    }
    .arco-radio-checked {
      background: #e8f3ff;
      border: 1px solid #3e88ff;

      .arco-radio-label {
        color: #3e88ff;
      }
    }

    .arco-input-wrapper {
      height: 36px;
      line-height: 36px;;
    }
    

    .button {
      width: 100%;
      display: flex;
      margin-top: 10px;

      .arco-btn {
        margin-right: 10px;
        width: calc((100% - 10px) / 2);
        height: 40px;
        line-height: 40px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>